<template>
  <div class="inner-container">

    <div style = "position: absolute; width: 100vw;z-index:99">
        <v-toolbar color="primary" dark fixed>
            <v-toolbar-side-icon @click.stop="drawer = !drawer"></v-toolbar-side-icon>
            <v-toolbar-title style="font-family: 'DINPro Regular'">{{ $router.history.current.path.split('/')[2]}}</v-toolbar-title>
            <v-spacer></v-spacer>
            <!--
            <v-btn icon>
                <v-icon>search</v-icon>
            </v-btn>
            -->
        </v-toolbar>
    </div>
   
    <v-navigation-drawer
      v-model="drawer"
      :mini-variant="mini"
      absolute
      dark
      temporary
      style="z-index:99999"
    >
      <v-list class="pa-1">
        <v-list-tile v-if="!mini" avatar tag="div">
          <v-list-tile-content>
            <v-list-tile-title style="font-family: 'DINPro Bold; letter-spacing:0.2rem'" >Navigation</v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>

        <v-divider light></v-divider>

        <v-list-tile 
            avatar 
            class="nav-tile" 
            tag="div"
            @click="routeTo('catagory')"
        >
          <v-list-tile-content>
            <v-list-tile-title style="font-family: 'DINPro Light'">Categories</v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>   

        <v-list-tile 
            avatar 
            tag="div"
            class="nav-tile"
            @click="routeTo('jewelry')"
        >
          <v-list-tile-content>
            <v-list-tile-title style="font-family: 'DINPro Light'">Jewelry</v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>   

        <v-divider light></v-divider>     
      </v-list>

    </v-navigation-drawer>
    <router-view></router-view>
  </div>
</template>

<script>

export default {
  created() {},
  data() {
    return {
       drawer: false,
       mini: false
    };
  },
  computed: {
  },
  methods: {
    routeTo(route) {
        this.drawer = false
        this.$router.push({name: route})
    }
  }
};
</script>

<style scoped>
.nav-tile {
    -webkit-transition: all 0.2s ease;
  -moz-transition: all 0.2s ease;
  -o-transition: all 0.2s ease;
  transition: all 0.2s ease;
}
.inner-container {
    background-color: white;
    min-height: 100vh;
}
#drawerButton {
    position: fixed;
}
.nav-tile:hover {
    cursor: pointer;
    box-shadow:rgba(0, 0, 0, 0.3) 0 16px 16px 0;
  -webkit-box-shadow:rgba(0, 0, 0, 0.3) 0 16px 16px 0;
  -moz-box-shadow:rgba(0, 0, 0, 0.3) 0 16px 16px 0;
}
</style>



// WEBPACK FOOTER //
// CmsContainer.vue?d8faa594